'use strict';

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = _assign2.default || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelectize = require('react-selectize');

var _helpers = require('../../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SimpleSelect = function SimpleSelect(props) {
  var onChange = props.onChange,
      options = props.options,
      value = props.value,
      groups = props.groups,
      renderTitle = props.renderTitle,
      getUniqueLabel = props.getUniqueLabel,
      reverseDropDown = props.reverseDropDown,
      otherProps = _objectWithoutProperties(props, ['onChange', 'options', 'value', 'groups', 'renderTitle', 'getUniqueLabel', 'reverseDropDown']);

  var selectedOption = options.find(function (o) {
    return o.value === value;
  });

  return _react2.default.createElement(
    'div',
    null,
    renderTitle(),
    _react2.default.createElement(_reactSelectize.SimpleSelect, _extends({
      value: selectedOption,
      groups: groups,
      options: options,
      filterOptions: _helpers.filterSimpleSelectOptions,
      onValueChange: function onValueChange(changedOption) {
        onChange(changedOption && changedOption.value);
      },
      renderValue: function renderValue(option) {
        return _react2.default.createElement(
          'div',
          { className: 'value-wrapper' },
          _react2.default.createElement(
            'div',
            { className: 'simple-value' },
            _react2.default.createElement(
              'span',
              null,
              getUniqueLabel(option)
            )
          )
        );
      },
      dropdownDirection: reverseDropDown ? -1 : 1
    }, otherProps))
  );
};

SimpleSelect.propTypes = {
  onChange: _propTypes2.default.func.isRequired,
  options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired
  })).isRequired,
  value: _propTypes2.default.string,
  groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    groupId: _propTypes2.default.string.isRequired
  })),
  renderTitle: _propTypes2.default.func,
  getUniqueLabel: _propTypes2.default.func,
  reverseDropDown: _propTypes2.default.bool,
  theme: _propTypes2.default.oneOf(['default', 'material', 'bootstrap3'])
};

SimpleSelect.defaultProps = {
  value: undefined,
  groups: [],
  renderTitle: function renderTitle() {
    return null;
  },
  getUniqueLabel: _helpers.getUniqueLabel,
  reverseDropDown: false,
  theme: 'default'
};

exports.default = SimpleSelect;